import axios from 'axios';
import { getApiUrl } from '../../../config/api';

/**
 * API client for the Market Trends tab — external talent-market intelligence
 * for a JD. Mirrors sourcingApi.js: the backend derives the company from the JD,
 * and we also pass company_email so it works when the session cookie isn't sent
 * cross-origin (staging vs. localhost).
 */

const ACTOR_KEYS = [
  'admin_email', 'employer_email', 'recruiter_email', 'company_email', 'organizer_email',
];

const readStored = (key) => {
  if (typeof window === 'undefined') return '';
  return window.sessionStorage.getItem(key) || window.localStorage.getItem(key) || '';
};

const getCompanyEmail = () => {
  if (typeof window === 'undefined') return '';
  for (const key of ACTOR_KEYS) {
    const v = readStored(key);
    if (v) return v.trim().toLowerCase();
  }
  return '';
};

/**
 * Fetch market insights for a job. Server caches per-JD for 7 days;
 * pass { refresh: true } to re-run the market research.
 */
export async function getMarketInsights(jobId, { refresh = false } = {}) {
  const params = {};
  const company = getCompanyEmail();
  if (company) params.company_email = company;
  if (refresh) params.refresh = 1;
  const res = await axios.get(
    getApiUrl(`/api/jobs/${encodeURIComponent(jobId)}/market-insights`),
    { params, withCredentials: true }
  );
  return res.data;
}
